import { useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { CreateSessionResponseEnum } from "@b2bportal/auth-api";
import { createSession } from "@b2bportal/core-auth";
import { useModuleBEM } from "@b2bportal/core-themes";
import { logger } from "@hopper-b2b/datadog";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useAuth } from "@hsbc/auth";
import { HOME_PATH, INVALID_SESSION_PATH } from "@hsbc/utilities";
import { Loading } from "@tenant/ui";
import styles from "./AuthorizeCodeLoginPage.module.scss";

export const AuthorizeCodeLoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "AuthorizeCodeLoginPage");

  useEffect(() => {
    const loginWithCode = async (code: string) => {
      try {
        const res = await createSession({
          CreateSessionRequest: "SignIn",
          authMethod: {
            AuthMethod: "PartnerToken",
            token: code,
          },
        });
        if (
          res.CreateSessionResponse ===
          CreateSessionResponseEnum.CreateSessionSuccess
        ) {
          login();
          navigate(HOME_PATH);
        } else {
          console.log("create session rejected:", res.CreateSessionResponse);
          navigate(INVALID_SESSION_PATH);
        }
      } catch (error) {
        // TODO: double check the error content from BE when ready, ensure no PII.
        logger().error("error creating session info:", { error });
        navigate(INVALID_SESSION_PATH);
      }
    };
    // get code query param from url
    const code = new URLSearchParams(window.location.search).get("code");
    if (code != null) {
      console.log("found authorize code in url:", code);
      loginWithCode(code);
    } else {
      console.log("no authorize code found in url");
      navigate(INVALID_SESSION_PATH);
    }
  }, [login, navigate]);

  return (
    <div className={block}>
      <Loading />
      <div className={cn("loading-text")}>{t("loading")} ...</div>
    </div>
  );
};
